export const config = {
  apiPrefix: "https://mytakedaresourceapi-dev.azurewebsites.net",
};
